import * as Sentry from "@sentry/react";

if (process.env.REACT_APP_MODE === "prod") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    beforeSend(event) {
      const frames = event?.exception?.values?.[0]?.stacktrace?.frames || [];
      
      const isFromGoogleAnalytics = frames.some(frame =>
        frame?.filename?.includes('google-analytics.com/analytics.js')
      );
      
      if (isFromGoogleAnalytics) return null;
      
      return event;
    },
  });
}
